<script>
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {},
  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    }
  }
};
</script>

<template>
  <!-- Topbar Start -->
  <div class="navbar-custom">
    <div class="container-fluid">
      <ul class="list-unstyled topnav-menu float-right mb-0">
        <li class="dropdown notification-list">
          <a class="navbar-toggle nav-link" @click="toggleMenu">
            <div class="lines">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </a>
        </li>

        <b-nav-item-dropdown right class="notification-list">
          <template slot="button-content">
            <div class="nav-user mr-0 waves-effect waves-light">
              Olá, {{ user ? user.nome : "" }}!
              <span class="pro-user-name ml-1">
                <i class="mdi mdi-chevron-down"></i>
              </span>
            </div>
          </template>

          <b-dropdown-item href="/AlterarSenha">
            <i class="remixicon-settings-3-line mr-2"></i>
            <span>Alterar minha senha</span>
          </b-dropdown-item>

          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="/Logout">
            <i class="remixicon-logout-box-line mr-2"></i>
            <span>Sair</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </ul>

      <!-- LOGO -->

      <div class="row">
        <div class="logo-box mt-2 float-left">
          <a href="/" class="logo text-center">
            <span class="logo-lg">
              <img
                src="@assets/images/logo-light.png"
                class="logo"
                alt=""
                height="50"
              />
            </span>
            <span class="logo-sm">
              <img
                src="@assets/images/logo-sm.png"
                class="logo-sm"
                alt=""
                height="50"
              />
            </span>
          </a>
        </div>
        <div class="float-left">
          <slot />
        </div>
      </div>
    </div>
  </div>
  <!-- end Topbar -->
</template>

<style lang="scss">
.notification-items {
  height: 220px;
}

.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}

.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
</style>
